"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: process.env.NODE_ENV === "production" ? {
    name: "bjn8wh",
    styles: "position:relative"
  } : {
    name: "1qtb3fn-default",
    styles: "position:relative;label:default;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  tooltip: theme => /*#__PURE__*/(0, _react.css)("position:absolute;left:0;top:100%;max-width:150px;margin-top:0.5em;padding:0.5em;background:#fff;border:1px solid ", theme.border, ";box-shadow:", theme.shadowSmallDarker, ";border-radius:5px;&::before{content:'';position:absolute;left:10px;top:-7px;width:0;height:0;border-style:solid;border-width:0 7px 7px 7px;border-color:transparent transparent ", theme.border, " transparent;z-index:9998;}&::after{content:'';position:absolute;left:12px;top:-5px;width:0;height:0;border-style:solid;border-width:0 5px 6px 5px;border-color:transparent transparent #fff transparent;z-index:9999;}" + (process.env.NODE_ENV === "production" ? "" : ";label:tooltip;"))
};